import { useDisclosure } from "@mantine/hooks";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  Box,
  Flex,
  Loader,
  LoadingOverlay,
  Title,
  Text,
  Group,
  Button,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";

const DeleteReasonRequestTransfer = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleDelete = async () => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblTransferReason/delete`,
        listId,
      );

      if (res && res.success) {
        NotificationExtension.Success("Xóa lý do YCDC thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess(true);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box maw={450} w={"30vw"} pt={10}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={12}>
                {" "}
                Hệ thống đang xử lý dữ liệu, vui lòng chờ trong giây lát ...
              </Title>
            </Flex>
          ),
        }}
      />
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa các lý do YCDC này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteReasonRequestTransfer;
